import {z} from 'zod'

export const PaginatedResponseSchema = z.object({
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  data: z.array(z.object({})),
})

export const createPaginatedResponse = <T extends z.ZodTypeAny>(
  itemSchema: T,
) =>
  PaginatedResponseSchema.extend({
    data: z.array(itemSchema),
  })
